import styled from 'styled-components';
import { colors } from '../styles/theme';

const Container = styled.div`
	position: absolute;
	top: 40%;
	left: ${({ leftAdjust }) => (leftAdjust ? 'calc(40% + 250px)' : '50%')};
	@media (max-width: 768px) {
		left: 50%;
	}
	transform: translate(-50%, 0px);
	.lds-ring {
		display: inline-block;
		position: relative;
		width: 80px;
		height: 80px;
	}
	.lds-ring div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 64px;
		height: 64px;
		margin: 8px;
		border: 8px solid ${colors.green};
		border-radius: 50%;
		animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		border-color: ${colors.green} transparent transparent transparent;
	}
	.lds-ring div:nth-child(1) {
		animation-delay: -0.45s;
	}
	.lds-ring div:nth-child(2) {
		animation-delay: -0.3s;
	}
	.lds-ring div:nth-child(3) {
		animation-delay: -0.15s;
	}
	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;

const Spinner = ({ leftAdjust }) => {
	return (
		<Container leftAdjust={leftAdjust}>
			<div className='lds-ring'>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</Container>
	);
};

export default Spinner;
